import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { ProjectDtoKeysEnum } from '@zaoblako/shared/modules/project/enum/project-dto-keys.enum';

import * as yup from 'yup';

/** Checklist reschedule API request body - DTO signature */
export interface ChecklistRescheduleInterface {
  /** Checklist item start date and time */
  startAt: Date;
  /** Checklist item end date and time */
  endAt: Date;
  /** Reschedule reason comment (text only) */
  reason?: string;
}

/** Checklist reschedule API request body - DTO schema */
export const ChecklistRescheduleDto = SerdeDtoClass.create<ChecklistRescheduleInterface>(ProjectDtoKeysEnum.CHECKLIST_RESCHEDULE_DTO, {
  startAt: {
    label: 'Дата и время начала',
    serializer: yup.date(),
  },
  endAt: {
    label: 'Дата и время окончания',
    hint: 'Планируемые дата и время, реальные могу отличаться',
    serializer: yup.date(),
  },
  reason: {
    optional: true,
    label: 'Причина переноса',
    serializer: yup.string(),
  },
});
